/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Faq_License_TermInputs */

const en_marketing_faq_license_term = /** @type {(inputs: Marketing_Faq_License_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is the license?`)
};

const es_marketing_faq_license_term = /** @type {(inputs: Marketing_Faq_License_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la licencia?`)
};

const fr_marketing_faq_license_term = /** @type {(inputs: Marketing_Faq_License_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la licence ?`)
};

/**
* | output |
* | --- |
* | "What is the license?" |
*
* @param {Marketing_Faq_License_TermInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_faq_license_term = /** @type {((inputs?: Marketing_Faq_License_TermInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Faq_License_TermInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_faq_license_term(inputs)
	if (locale === "es") return es_marketing_faq_license_term(inputs)
	return fr_marketing_faq_license_term(inputs)
});